export default __webpack_public_path__ + "static/media/xls-icon.8e27b4ff.svg";